import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig';
import { DistributionHubListResp } from 'domain/payload/response/distributionHub/DistributionHubListResp';
import { DistributionHubCreateReq } from 'domain/payload/request/distributionHub/DistributionHubCreateReq';
import { DistributionHubDetailResp } from 'domain/payload/response/distributionHub/DistributionHubDetailResp';
import { DistributionHubUpdateReq } from 'domain/payload/request/distributionHub/DistributionHubUpdateReq';
import { DistributionHubMoreAccessUserListConfigResp } from 'domain/payload/response/distributionHub/DistributionHubMoreAccessUserListConfig';
import { DistributionHubAreaConfigResp } from 'domain/payload/response/distributionHub/DistributionHubAreaConfigResp';
import { DistributionHubGeoListResp } from 'domain/payload/response/distributionHub/DistributionHubGeoListResp';

const DistributionHubService = () => {
    const distributionHubList = async (
        token: string,
        search: string | null,
        page: number | null,
        size: number | null
    ): Promise<BaseResponse<DistributionHubListResp[]>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/distribution-hub/list`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    search: search,
                    page: page,
                    size: size
                }
            });

            return response.data;

        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubGeoList = async (
        token: string,
    ): Promise<BaseResponse<DistributionHubGeoListResp[]>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/distribution-hub/geo-list`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;

        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubDetail = async (
        token: string,
        id: string
    ): Promise<BaseResponse<DistributionHubDetailResp>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/distribution-hub/detail`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    id
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubMoreAccessUserListConfig = async (
        token: string
    ): Promise<BaseResponse<DistributionHubMoreAccessUserListConfigResp[]>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/distribution-hub/user-config`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubCreate = async (
        token: string,
        request: DistributionHubCreateReq
    ): Promise<BaseResponse<DistributionHubDetailResp>> => {
        try {
            const response = await axiosInstance.post(`/v1/legacy/cms/distribution-hub/create`, request, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubUpdate = async (
        token: string,
        request: DistributionHubUpdateReq
    ): Promise<BaseResponse<DistributionHubDetailResp>> => {
        try {
            const response = await axiosInstance.put(`/v1/legacy/cms/distribution-hub/update`, request, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubDelete = async (
        token: string,
        id: string
    ): Promise<BaseResponse<any>> => {
        try {
            const response = await axiosInstance.delete(`/v1/legacy/cms/distribution-hub/delete?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const distributionHubAreaConfig = async (
        token: string,
        lat?: number,
        lng?: number
    ): Promise<BaseResponse<DistributionHubAreaConfigResp | DistributionHubAreaConfigResp[] | any>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/distribution-hub/area-config`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    lat, lng
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response?.data?.message || error.message || error;
        }
    };

    return { distributionHubList, distributionHubGeoList, distributionHubCreate, distributionHubDetail, distributionHubMoreAccessUserListConfig, distributionHubUpdate, distributionHubDelete, distributionHubAreaConfig };
};

export default DistributionHubService;